module.exports = __webpack_public_path__ + "img/networkSecWebinar.37be535b.png";